<template>
    <va-form :id="id" :item="item">
        <v-row justify="center">
            <v-col sm="6">
                <base-material-card>
                    <template v-slot:heading>
                        <div class="display-2">
                            {{ title }}
                        </div>
                    </template>
                    <v-card-text>
                        <va-text-input source="id"></va-text-input>
                        <va-text-input source="name"></va-text-input>
                        <va-text-input source="countryCode"></va-text-input>
                        <va-text-input
                            source="defaultCurrencyCode"
                        ></va-text-input>
                        <va-text-input
                            source="defaultLanguageCode"
                        ></va-text-input>
                        <va-text-input source="domainName"></va-text-input>
                        <va-date-input source="created_at"></va-date-input>
                        <va-date-input source="updated_at"></va-date-input>
                    </v-card-text>
                    <va-save-button></va-save-button>
                </base-material-card>
            </v-col>
        </v-row>
    </va-form>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
